import React from 'react';
import { Typography, Grid } from 'antd';
import { useTranslation } from 'react-i18next';

import { CompanyForm } from '@Features/signin-forms';

const { Title } = Typography;
const { useBreakpoint } = Grid;

const styles: Record<string, React.CSSProperties> = {
    // The same card as step 1 (AuthStep).
    main: {
        width: 'min(calc(100vw - 40px), 500px)',
        height: 'fit-content',
        // The padding is inside the 500 px, as in step 1's card; outside it this card came out 580 px wide.
        boxSizing: 'border-box',
    },
    bg: {
        position: 'fixed',
        zIndex: -1,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    },
};

export default function CompanyStep({ handleStep }: { handleStep: (arg1: number) => void }) {
    const { t } = useTranslation('translation', { keyPrefix: 'signup' });
    const breakpoints = useBreakpoint();

    return (
        <div style={{ ...styles.main, padding: breakpoints.lg ? 40 : 20 }}>
            <Title
                level={4}
                style={{ marginTop: 0, marginBottom: 24, textAlign: 'center' }}
            >
                {t('company_step.title')}
            </Title>

            <CompanyForm handleStep={handleStep} />
        </div>
    );
}
